import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormProvider from './form/FormProvider'

function NewProvider({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerProvider(provider) {
        let msgType = 'success'

        const data = await api.post('/provider/new', provider, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormProvider title="Cadastrar Fornecedor" handleSubmit={registerProvider} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewProvider
